import { Route, Switch } from 'react-router-dom';
import Groups from './groups/Groups.component';
import Permission from './permission/Permission.component';
import Functionality from './functionality/Functionality.component';
import Component from './component/Component.component';
import UserStore from './userStore/UserStore.component';
import ImportDataSecurity from './importData/ImportData.component';
import DirectorFlagComponent from './directorFlag/DirectorFlag.component';
import ManagerRegionComponent from './managerRegions/ManagerRegion.component';
import ManagerStoreComponent from './managerStore/ManagerStore.component';
import ProcessQueueComponent from './processQueue/ProcessQueue.component';

const Routes = () => {
  return (
    <Switch>
      <Route exact path='/seguranca/grupos' component={Groups} />
      <Route exact path='/seguranca' component={UserStore} />
      <Route exact path='/seguranca/gerenteloja' component={ManagerStoreComponent} />
      <Route exact path='/seguranca/gerenteregional' component={ManagerRegionComponent} />
      <Route exact path='/seguranca/diretorbandeira' component={DirectorFlagComponent} />
      <Route exact path='/seguranca/permissoes' component={Permission} />
      <Route exact path='/seguranca/funcionalidade' component={Functionality} />
      <Route exact path='/seguranca/funcionalidade/:id' component={Component} />
      <Route exact path='/seguranca/importar' component={ImportDataSecurity} />
      <Route exact path='/seguranca/processamento' component={ProcessQueueComponent} />
      <Route component={() => <>Não encontrado</>} />
    </Switch>
  );
};

export default Routes;
